
import { Component, Injector, NgZone } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { Dashboard } from '../dashboard/dashboard';
import { UserLogin } from '../user-login/user-login';
import { UserForgotpassword } from '../user-forgotpassword/user-forgotpassword';
import { Util } from '../../app/util';
import { HrListCampionatiPage } from '../hr_listcampionati/hr_listcampionati';
import { TranslateService } from '@ngx-translate/core';
import { EthemeProvider } from '../../providers/etheme/etheme';
var docsrc = '';

@IonicPage()
@Component({
  selector: 'page-hr_emailinvito',
  templateUrl: 'hr_emailinvito.html',
})
export class HrEmailInvito extends Util {

  params: any = {oggetto: '', email: '', tags: [], cid: ''};
  campionato_id: any;
  constructor(public navCtrl: NavController, public translate: TranslateService, public navParams: NavParams, injector: Injector, private zone: NgZone, public etheme: EthemeProvider) {
    super(injector, null);
    this.campionato_id = this.navParams.get('campionato');
    this.params.cid = this.campionato_id;
    // this.params_grafici = this.navParams.get('params_grafici'); 
    // console.log(this.params_grafici);
    // console.log(this.etheme.theme_selected);
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad UserSignup');
    // this.squadre = [{nome:'tigri',id:20},{nome:'leoni',id:21}];
    this.GetRequest('hr_email_invito', this.campionato_id, true, false).then((res) => {
      this.params = res;
      this.params.cid = this.campionato_id; 
      console.log(res);
      // if (sq != null && sq['SquadraList'] != null)
      //   this.squadre = sq['SquadraList'];
    }).catch((err) => {
      console.error(err);
    })
  }

  go_root() {
    this.navCtrl.setRoot(HrListCampionatiPage);
  }
  back() {
    // if(this.refresh_dashboard == false)
    this.navCtrl.pop({ animate: false });
    // else
    //   this.go_root();
  }


  save() {

    this.PostRequest('hr_email_invito', '', this.params).then((data) => {
      this.back();
    }).catch(err => {
      console.error(err);
      // this.showBasicAlert('Errore',err)
    });

  }
}



// WEBPACK FOOTER //
// ./src/pages/hr_emailinvito/hr_emailinvito.ts